/**
 * Plugin per l'installazione del componenente WorldMenu e del relativo modulo dello store
 * con le opzioni giuste
 */
import WorldMenu from '../components/WorldMenu.vue';
import MenuModule from '../storeModules/menu';

export default {
  install(Vue, { store }) {
    /**
     * Deve essere necessariamente passata l'istanza di vuex store
     */
    if(!store) {
      throw new Error("Please provide vuex store");
    }

    /**
     * Registrazione del modulo dello store associato al menu
     */
    store.registerModule('menu', MenuModule);

    /**
     * Registrazione componente del menu
     */
    Vue.component('world-menu', WorldMenu);
  }
}